// wa.me deep-link helper. Preserves line breaks, ₹, emoji.
export function waLink(phone, message) {
  const clean = (phone || '').replace(/[^\d]/g, '');
  const text = encodeURIComponent(message || '');
  return clean ? `https://wa.me/${clean}?text=${text}` : `https://wa.me/?text=${text}`;
}

export function mergeTemplate(body, vars) {
  return String(body || '').replace(/\{(\w+)\}/g, (m, k) => (vars[k] ?? m));
}
